/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminProStatsEmailsResponse } from '../models';
// @ts-ignore
import type { AdminProStatsLifecycleResponse } from '../models';
// @ts-ignore
import type { AdminProStatsMemberDetailResponse } from '../models';
// @ts-ignore
import type { AdminProStatsMembersResponse } from '../models';
// @ts-ignore
import type { AdminProStatsOverviewResponse } from '../models';
// @ts-ignore
import type { AdminProStatsTimeseriesResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
/**
 * ProStatsApiApi - axios parameter creator
 */
export const ProStatsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsEmails: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/pro-statistics/emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {ProStatsApiGetAdminProStatsLifecycleGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsLifecycle: async (endDate?: string | null, excludeInternal?: boolean, granularity?: ProStatsApiGetAdminProStatsLifecycleGranularityEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/pro-statistics/lifecycle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsMember: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('proStatsApiGetAdminProStatsMember', 'userId', userId)
            const localVarPath = `/admin/pro-statistics/members/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProStatsApiGetAdminProStatsMembersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {ProStatsApiGetAdminProStatsMembersSortByEnum} [sortBy] 
         * @param {ProStatsApiGetAdminProStatsMembersSortOrderEnum} [sortOrder] 
         * @param {ProStatsApiGetAdminProStatsMembersSourceEnum} [source] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsMembers: async (activity?: ProStatsApiGetAdminProStatsMembersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: ProStatsApiGetAdminProStatsMembersSortByEnum, sortOrder?: ProStatsApiGetAdminProStatsMembersSortOrderEnum, source?: ProStatsApiGetAdminProStatsMembersSourceEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/pro-statistics/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * the benefits they use, and who needs a look.
         * @summary Today\'s Pro members by source, their activity against the window before,
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsOverview: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/pro-statistics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {ProStatsApiGetAdminProStatsTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsTimeseries: async (endDate?: string | null, excludeInternal?: boolean, granularity?: ProStatsApiGetAdminProStatsTimeseriesGranularityEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/pro-statistics/timeseries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProStatsApiApi - functional programming interface
 */
export const ProStatsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProStatsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proStatsApiGetAdminProStatsEmails(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProStatsEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proStatsApiGetAdminProStatsEmails(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProStatsApiApi.proStatsApiGetAdminProStatsEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {ProStatsApiGetAdminProStatsLifecycleGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proStatsApiGetAdminProStatsLifecycle(endDate?: string | null, excludeInternal?: boolean, granularity?: ProStatsApiGetAdminProStatsLifecycleGranularityEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProStatsLifecycleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proStatsApiGetAdminProStatsLifecycle(endDate, excludeInternal, granularity, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProStatsApiApi.proStatsApiGetAdminProStatsLifecycle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proStatsApiGetAdminProStatsMember(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProStatsMemberDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proStatsApiGetAdminProStatsMember(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProStatsApiApi.proStatsApiGetAdminProStatsMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProStatsApiGetAdminProStatsMembersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {ProStatsApiGetAdminProStatsMembersSortByEnum} [sortBy] 
         * @param {ProStatsApiGetAdminProStatsMembersSortOrderEnum} [sortOrder] 
         * @param {ProStatsApiGetAdminProStatsMembersSourceEnum} [source] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proStatsApiGetAdminProStatsMembers(activity?: ProStatsApiGetAdminProStatsMembersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: ProStatsApiGetAdminProStatsMembersSortByEnum, sortOrder?: ProStatsApiGetAdminProStatsMembersSortOrderEnum, source?: ProStatsApiGetAdminProStatsMembersSourceEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProStatsMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proStatsApiGetAdminProStatsMembers(activity, endDate, excludeInternal, page, pageSize, search, sortBy, sortOrder, source, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProStatsApiApi.proStatsApiGetAdminProStatsMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * the benefits they use, and who needs a look.
         * @summary Today\'s Pro members by source, their activity against the window before,
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proStatsApiGetAdminProStatsOverview(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProStatsOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proStatsApiGetAdminProStatsOverview(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProStatsApiApi.proStatsApiGetAdminProStatsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {ProStatsApiGetAdminProStatsTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proStatsApiGetAdminProStatsTimeseries(endDate?: string | null, excludeInternal?: boolean, granularity?: ProStatsApiGetAdminProStatsTimeseriesGranularityEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProStatsTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proStatsApiGetAdminProStatsTimeseries(endDate, excludeInternal, granularity, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProStatsApiApi.proStatsApiGetAdminProStatsTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProStatsApiApi - factory interface
 */
export const ProStatsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProStatsApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ProStatsApiApiProStatsApiGetAdminProStatsEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsEmails(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsEmailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProStatsEmailsResponse> {
            return localVarFp.proStatsApiGetAdminProStatsEmails(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProStatsApiApiProStatsApiGetAdminProStatsLifecycleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsLifecycle(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsLifecycleRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProStatsLifecycleResponse> {
            return localVarFp.proStatsApiGetAdminProStatsLifecycle(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProStatsApiApiProStatsApiGetAdminProStatsMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsMember(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProStatsMemberDetailResponse> {
            return localVarFp.proStatsApiGetAdminProStatsMember(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProStatsApiApiProStatsApiGetAdminProStatsMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsMembers(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsMembersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProStatsMembersResponse> {
            return localVarFp.proStatsApiGetAdminProStatsMembers(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.source, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * the benefits they use, and who needs a look.
         * @summary Today\'s Pro members by source, their activity against the window before,
         * @param {ProStatsApiApiProStatsApiGetAdminProStatsOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsOverview(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProStatsOverviewResponse> {
            return localVarFp.proStatsApiGetAdminProStatsOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProStatsApiApiProStatsApiGetAdminProStatsTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proStatsApiGetAdminProStatsTimeseries(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsTimeseriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProStatsTimeseriesResponse> {
            return localVarFp.proStatsApiGetAdminProStatsTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for proStatsApiGetAdminProStatsEmails operation in ProStatsApiApi.
 */
export interface ProStatsApiApiProStatsApiGetAdminProStatsEmailsRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for proStatsApiGetAdminProStatsLifecycle operation in ProStatsApiApi.
 */
export interface ProStatsApiApiProStatsApiGetAdminProStatsLifecycleRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly granularity?: ProStatsApiGetAdminProStatsLifecycleGranularityEnum

    readonly startDate?: string | null
}

/**
 * Request parameters for proStatsApiGetAdminProStatsMember operation in ProStatsApiApi.
 */
export interface ProStatsApiApiProStatsApiGetAdminProStatsMemberRequest {
    readonly userId: string
}

/**
 * Request parameters for proStatsApiGetAdminProStatsMembers operation in ProStatsApiApi.
 */
export interface ProStatsApiApiProStatsApiGetAdminProStatsMembersRequest {
    readonly activity?: ProStatsApiGetAdminProStatsMembersActivityEnum

    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: ProStatsApiGetAdminProStatsMembersSortByEnum

    readonly sortOrder?: ProStatsApiGetAdminProStatsMembersSortOrderEnum

    readonly source?: ProStatsApiGetAdminProStatsMembersSourceEnum

    readonly startDate?: string | null
}

/**
 * Request parameters for proStatsApiGetAdminProStatsOverview operation in ProStatsApiApi.
 */
export interface ProStatsApiApiProStatsApiGetAdminProStatsOverviewRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for proStatsApiGetAdminProStatsTimeseries operation in ProStatsApiApi.
 */
export interface ProStatsApiApiProStatsApiGetAdminProStatsTimeseriesRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly granularity?: ProStatsApiGetAdminProStatsTimeseriesGranularityEnum

    readonly startDate?: string | null
}

/**
 * ProStatsApiApi - object-oriented interface
 */
export class ProStatsApiApi extends BaseAPI {
    /**
     * 
     * @param {ProStatsApiApiProStatsApiGetAdminProStatsEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proStatsApiGetAdminProStatsEmails(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsEmailsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProStatsApiApiFp(this.configuration).proStatsApiGetAdminProStatsEmails(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProStatsApiApiProStatsApiGetAdminProStatsLifecycleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proStatsApiGetAdminProStatsLifecycle(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsLifecycleRequest = {}, options?: RawAxiosRequestConfig) {
        return ProStatsApiApiFp(this.configuration).proStatsApiGetAdminProStatsLifecycle(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProStatsApiApiProStatsApiGetAdminProStatsMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proStatsApiGetAdminProStatsMember(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsMemberRequest, options?: RawAxiosRequestConfig) {
        return ProStatsApiApiFp(this.configuration).proStatsApiGetAdminProStatsMember(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProStatsApiApiProStatsApiGetAdminProStatsMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proStatsApiGetAdminProStatsMembers(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsMembersRequest = {}, options?: RawAxiosRequestConfig) {
        return ProStatsApiApiFp(this.configuration).proStatsApiGetAdminProStatsMembers(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.source, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * the benefits they use, and who needs a look.
     * @summary Today\'s Pro members by source, their activity against the window before,
     * @param {ProStatsApiApiProStatsApiGetAdminProStatsOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proStatsApiGetAdminProStatsOverview(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return ProStatsApiApiFp(this.configuration).proStatsApiGetAdminProStatsOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProStatsApiApiProStatsApiGetAdminProStatsTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proStatsApiGetAdminProStatsTimeseries(requestParameters: ProStatsApiApiProStatsApiGetAdminProStatsTimeseriesRequest = {}, options?: RawAxiosRequestConfig) {
        return ProStatsApiApiFp(this.configuration).proStatsApiGetAdminProStatsTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ProStatsApiGetAdminProStatsLifecycleGranularityEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
} as const;
export type ProStatsApiGetAdminProStatsLifecycleGranularityEnum = typeof ProStatsApiGetAdminProStatsLifecycleGranularityEnum[keyof typeof ProStatsApiGetAdminProStatsLifecycleGranularityEnum];
export const ProStatsApiGetAdminProStatsMembersActivityEnum = {
    Active: 'active',
    Quiet: 'quiet',
} as const;
export type ProStatsApiGetAdminProStatsMembersActivityEnum = typeof ProStatsApiGetAdminProStatsMembersActivityEnum[keyof typeof ProStatsApiGetAdminProStatsMembersActivityEnum];
export const ProStatsApiGetAdminProStatsMembersSortByEnum = {
    LastSeenAt: 'last_seen_at',
    ProUntil: 'pro_until',
    Since: 'since',
    Applications: 'applications',
    ActiveDays: 'active_days',
    Trend: 'trend',
    EmailsSent: 'emails_sent',
    Name: 'name',
} as const;
export type ProStatsApiGetAdminProStatsMembersSortByEnum = typeof ProStatsApiGetAdminProStatsMembersSortByEnum[keyof typeof ProStatsApiGetAdminProStatsMembersSortByEnum];
export const ProStatsApiGetAdminProStatsMembersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type ProStatsApiGetAdminProStatsMembersSortOrderEnum = typeof ProStatsApiGetAdminProStatsMembersSortOrderEnum[keyof typeof ProStatsApiGetAdminProStatsMembersSortOrderEnum];
export const ProStatsApiGetAdminProStatsMembersSourceEnum = {
    Trial: 'trial',
    Paying: 'paying',
    Cancelled: 'cancelled',
    PaymentIssue: 'payment_issue',
    Ambassador: 'ambassador',
    Other: 'other',
} as const;
export type ProStatsApiGetAdminProStatsMembersSourceEnum = typeof ProStatsApiGetAdminProStatsMembersSourceEnum[keyof typeof ProStatsApiGetAdminProStatsMembersSourceEnum];
export const ProStatsApiGetAdminProStatsTimeseriesGranularityEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
} as const;
export type ProStatsApiGetAdminProStatsTimeseriesGranularityEnum = typeof ProStatsApiGetAdminProStatsTimeseriesGranularityEnum[keyof typeof ProStatsApiGetAdminProStatsTimeseriesGranularityEnum];
